import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import * as S from './styles';

export default function RoundItem({
  dates,
  selected,
  selectDate,
  rounds,
  showSeparator,
}) {
  const { t } = useTranslation();
  return (
    <S.Wrapper onClick={selectDate}>
      <S.DayContainer>
        <S.Date selected={selected} className="date-mobile">
          {dates}
        </S.Date>
        <S.MatchesContainer>
          {rounds.map(({ logo, number, competition }) => {
            return (
              <S.MatchItem key={v4()}>
                <S.MatchCompetitionLogo src={logo} competitionLogo={logo} />
                <S.MatchInfo competition={competition} selected={selected}>
                  <S.MatchRound>{t('round')}</S.MatchRound>
                  <S.RoundNumber>{number}</S.RoundNumber>
                </S.MatchInfo>
              </S.MatchItem>
            );
          })}
        </S.MatchesContainer>
        <S.Date selected={selected} className="date-desktop">
          {dates}
        </S.Date>
      </S.DayContainer>
      {!showSeparator && <S.Separator />}
    </S.Wrapper>
  );
}

RoundItem.propTypes = {
  dates: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  selectDate: PropTypes.func.isRequired,
  rounds: PropTypes.array.isRequired,
  showSeparator: PropTypes.bool.isRequired,
};
